import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from '@mui/material';

export default function TableSkeleton() {
  const skeletonRows = 20;
  const skeletonColumns = 8;

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <Table
        sx={{
          width: "100%",
          tableLayout: "auto",
        }}
        aria-label="table skeleton"
        size="small"
      >
        <TableHead>
          <TableRow sx={{ height: "50px" }}>
            <TableCell sx={{ width: "50px", py: 2 }}>
              <Skeleton variant="rectangular" width={20} height={20} />
            </TableCell>
            {Array.from({ length: skeletonColumns }).map((_, index) => (
              <TableCell key={index} sx={{ py: 2 }}>
                <Skeleton variant="text" width="80%" height={20} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {Array.from({ length: skeletonRows }).map((_, rowIndex) => (
            <TableRow key={rowIndex} sx={{ height: "50px" }}>
              <TableCell sx={{ width: "50px", py: 2 }}>
                <Skeleton variant="rectangular" width={20} height={20} />
              </TableCell>
              {Array.from({ length: skeletonColumns }).map((_, colIndex) => (
                <TableCell key={colIndex} sx={{ py: 2 }}>
                  <Skeleton variant="text" width="70%" height={16} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
